<loader-detail *ngIf="!bestprice && busy; else priceBoxContent"></loader-detail>
<ng-template #priceBoxContent>
  <div class="mobile-wrapper" *ngIf="isMobile; else desktopTemplate">
    <best-room-pricebox-mobile
      [hotelId]="hotelStatic.id"
      [bestAvailable]="bestAvailable"
      [isLanding]="isLanding"
      [showAmountTotal]="showAmountTotal"
      [city]="hotelStatic.city"
      [country]="hotelStatic.country"
      [hotelName]="hotelStatic.name"
      [hotelStars]="hotelStatic.stars"
      [isDisney]="isDisney"
      (selectTab)="goToRoomsTab()"
    ></best-room-pricebox-mobile>
  </div>

  <ng-template #desktopTemplate>
    <div class="desktop-wrapper">
      <ng-container
        *ngIf="
          bestAvailable?.rates &&
          (bestAvailable?.rates)[0] &&
          (bestAvailable?.rates)[0]?.provider
        "
      >
        <div class="provider-info-container">
          <provider-info
            [cluster]="bestAvailable"
            [isExperts]="isExperts"
          ></provider-info>
        </div>
      </ng-container>

      <best-room-pricebox
        [hotelId]="hotelStatic.id"
        [bestAvailable]="bestAvailable"
        [landing]="isLanding"
        [showAmountTotal]="showAmountTotal"
        [city]="hotelStatic.city"
        [country]="hotelStatic.country"
        [hotelName]="hotelStatic.name"
        [hotelStars]="hotelStatic.stars"
        [isDisney]="isDisney"
      ></best-room-pricebox>
    </div>
  </ng-template>
</ng-template>
